// Fill in each path as the API list is provided, grouped by the page/feature that calls it.
// All paths go through one gateway (REACT_APP_API_BASE_URL); the prefix routes to the
// backend service behind it — "/sfa" for user/auth, "/rem" for lead/loan data,
// "/core/commonservice" for shared reference data (e.g. state/city master lists).
export const ENDPOINTS = {
  common: {
    stateCityAll: "/core/commonservice/state_city_all",
    docsUpload: "/core/commonservice/docs_upload",
  },
  auth: {
    login: "/sfa/user_auth/user_login",
    loginByMobileGetOtp: "/sfa/user_auth/otp-login",
    loginByMobileVerifyOtp: '/sfa/user/verifyOtp',
    forgotPasswordSendOtp: '/sfa/user/forgot-password',
    forgotPasswordVerifyOtp: '/sfa/user/validate-otp',
    joinUs: '/sfa/user/join-us',
    logout: "/sfa/user/user_logout",
    config: "/rem/config/get"
  },
  dashboard: {
    getDashboardBuckets: "/rem/lead/get_dashboard_buckets",
    getLeads: "/rem/lead/get_leads",
  },
  applicationForm: {
    createProspect: "/rem/lead/create_prospect",
    partnerList: "/rem/config/partner-list",
    addFinancier: "/rem/lead/add_financier",
    getLeadDetails: "/rem/lead/get_lead_details",
    uploadDoc: "/rem/lead/upload_doc",
    getDocs: "/rem/lead/get_docs",
    saveDocs: "/rem/lead/save_docs",
    saveLeadData: "/rem/lead/save_lead_data",
  },
  postApplication: {
    saveNoa: "/rem/lead/save_noa",
    extractNoa: "/rem/lead/extract_noa",
    saveContract: "/rem/lead/save_contract",
    getSentToFinancier: "/rem/lead/get_sent_to_financier",
    sentToFinancier: "/rem/lead/sent_to_financier",
    saveRemark: "/rem/lead/save_remark",
    getRemarks: "/rem/lead/get_remarks",
  },
};
